// import { useState } from "react";
// import styles from "./LifeStageScreen.module.css";

// const STAGES = [
//   {
//     id: "adolescence",
//     label: "Adolescence",
//     age: "13–19 years",
//     emoji: "👧",
//     color: "#BA68C8",
//     bg: "#F3E5F5",
//     desc: "A transformative phase of growth, self-discovery, and building healthy habits that last a lifetime.",
//     tags: ["Hormonal changes", "Period health", "Nutrition", "Mental wellness"],
//     status: "completed",
//   },
//   {
//     id: "reproductive",
//     label: "Reproductive Health",
//     age: "26–35 years",
//     emoji: "👩",
//     color: "#4A148C",
//     bg: "#EDE7F6",
//     desc: "A phase of building health, managing hormones, planning your future and achieving your goals.",
//     tags: ["Hormonal balance", "Fertility planning", "PCOS care", "Lifestyle", "Mental wellbeing"],
//     status: "current",
//     focusAreas: [
//       { icon: "⚖️", text: "Hormonal balance" },
//       { icon: "🌙", text: "Menstrual & cycle health" },
//       { icon: "🔬", text: "PCOS & hormonal conditions" },
//       { icon: "💫", text: "Fertility & family planning" },
//       { icon: "🥗", text: "Nutrition & fitness" },
//       { icon: "💜", text: "Mental wellbeing" },
//     ],
//   },
//   {
//     id: "fertility",
//     label: "Fertility & Family Planning",
//     age: "Planning your future",
//     emoji: "❤️",
//     color: "#E91E63",
//     bg: "#FCE4EC",
//     desc: "Understanding fertility, planning for the future, and making informed decisions about family.",
//     tags: ["Fertility tracking", "Preconception care", "IVF support"],
//     status: "upcoming",
//   },
//   {
//     id: "pregnancy",
//     label: "Pregnancy",
//     age: "Nurturing new life",
//     emoji: "🤰",
//     color: "#E91E63",
//     bg: "#FCE4EC",
//     desc: "Supporting you through every trimester with expert guidance and compassionate care.",
//     tags: ["Prenatal care", "Nutrition", "Mental health"],
//     status: "upcoming",
//   },
//   {
//     id: "postpartum",
//     label: "Postpartum",
//     age: "Recovery & new beginnings",
//     emoji: "🍼",
//     color: "#F06292",
//     bg: "#FCE4EC",
//     desc: "Recovery, bonding, and adjusting to life's most beautiful new chapter.",
//     tags: ["Recovery", "Breastfeeding", "Baby blues"],
//     status: "upcoming",
//   },
//   {
//     id: "perimenopause",
//     label: "Perimenopause",
//     age: "Hormonal transitions",
//     emoji: "🌸",
//     color: "#FFA000",
//     bg: "#FFF4E5",
//     desc: "Navigating hormonal shifts with grace, knowledge, and the right support.",
//     tags: ["Hot flashes", "Mood changes", "Sleep health"],
//     status: "upcoming",
//   },
//   {
//     id: "menopause",
//     label: "Menopause",
//     age: "Embrace the change",
//     emoji: "🦋",
//     color: "#FF7043",
//     bg: "#FBE9E7",
//     desc: "A new chapter of freedom and wisdom. Thrive through the change.",
//     tags: ["HRT", "Bone health", "Cardiovascular"],
//     status: "upcoming",
//   },
//   {
//     id: "aging",
//     label: "Healthy Aging",
//     age: "60+ years",
//     emoji: "✨",
//     color: "#4CAF50",
//     bg: "#E8F5E9",
//     desc: "Vibrant, active aging with focus on longevity, vitality, and joyful living.",
//     tags: ["Bone density", "Cognitive health", "Active lifestyle"],
//     status: "upcoming",
//   },
// ];

// const RECOMMENDATIONS = [
//   {
//     id: "pcos",
//     title: "PCOS Risk Assessment",
//     desc: "Understand your risk and get personalized insights.",
//     icon: "🔬",
//     iconBg: "#F3E5F5",
//     type: "Assessment",
//     typeColor: "#4CAF50",
//     typeBg: "#E8F5E9",
//     link: "/health-assessment",
//   },
//   {
//     id: "hormonal",
//     title: "Hormonal Balance Program",
//     desc: "Balance your hormones and feel your best.",
//     icon: "🌿",
//     iconBg: "#E8F5E9",
//     type: "Program",
//     typeColor: "#4A148C",
//     typeBg: "#EDE7F6",
//     link: "/programs",
//   },
//   {
//     id: "nutrition",
//     title: "Nutrition for Hormone Health",
//     desc: "Personalized diet plans for hormonal balance.",
//     icon: "🥗",
//     iconBg: "#FFF4E5",
//     type: "Program",
//     typeColor: "#FFA000",
//     typeBg: "#FFF8E1",
//     link: "/programs",
//   },
//   {
//     id: "consult",
//     title: "Book a Gynecologist",
//     desc: "Consult a specialist for personalized care.",
//     icon: "📋",
//     iconBg: "#FCE4EC",
//     type: "Consult",
//     typeColor: "#E91E63",
//     typeBg: "#FCE4EC",
//     link: "/book-appointment",
//   },
// ];

// const ALSO_LIKE = [
//   {
//     id: "stress",
//     title: "Stress & Anxiety Support",
//     desc: "Improve your mental wellbeing and reduce stress.",
//     icon: "🧠",
//     iconBg: "#EDE7F6",
//     type: "Program",
//     typeColor: "#4A148C",
//     typeBg: "#EDE7F6",
//     link: "/programs",
//   },
//   {
//     id: "fitness",
//     title: "Active Lifestyle Program",
//     desc: "Tailored fitness routines for your life stage.",
//     icon: "🏃‍♀️",
//     iconBg: "#FFF4E5",
//     type: "Program",
//     typeColor: "#FFA000",
//     typeBg: "#FFF8E1",
//     link: "/programs",
//   },
// ];

// const SUPPORT_ITEMS = [
//   { icon: "💬", text: "Answer your health questions" },
//   { icon: "🔍", text: "Help you understand symptoms" },
//   { icon: "🧭", text: "Guide you to the right care" },
//   { icon: "✅", text: "Track your health & progress" },
//   { icon: "⭐", text: "Recommend programs & experts" },
//   { icon: "🎉", text: "Celebrate your milestones" },
// ];

// const LIFE_STAGE_GRID = [
//   { id: "adolescence", label: "Adolescence", icon: "👧" },
//   { id: "reproductive", label: "Reproductive Age", icon: "👩" },
//   { id: "pregnancy", label: "Pregnancy", icon: "🤰" },
//   { id: "40plus", label: "40+", icon: "👱‍♀️" },
// ];

// const TABS = [
//   { id: "detail", label: "My Stage", icon: "💜" },
//   { id: "journey", label: "Journey", icon: "🗺️" },
//   { id: "recs", label: "Recs", icon: "⭐" },
//   { id: "support", label: "Support", icon: "🤝" },
// ];

// /* ─── Selection Grid Screen ─── */
// function SelectionGrid({ onSelect }) {
//   return (
//     <div className={styles.screenWrap}>
//       <div className={styles.pageHead}>
//         <h2 className={styles.pageTitle}>Life Stage</h2>
//         <p className={styles.pageSub}>Select the stage that best describes you</p>
//       </div>
//       <div className={styles.grid}>
//         {LIFE_STAGE_GRID.map(({ id, label, icon }) => (
//           <button key={id} className={styles.gridCard} onClick={() => onSelect(id)}>
//             <div className={styles.gridIcon}>{icon}</div>
//             <span className={styles.gridLabel}>{label}</span>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ─── Stage Detail Screen ─── */
// function StageDetailScreen({ stage, onSeeActions }) {
//   return (
//     <div className={styles.screenWrap}>
//       <div className={styles.chatRow}>
//         <img
//             src="/images/chatbotFemCare.svg"
//             alt="Avexa AI Chatbot"
//             width={52}
//             height={52}
//             className={styles.avatar}
//           />
//         <div>
//           <div className={styles.chatBubble}>
//             Based on your responses, you are in the{" "}
//             <strong>{stage.label}</strong> stage.
//           </div>
//           <div className={styles.chatTime}>10:32 AM</div>
//         </div>
//       </div>

//       <div className={styles.heroCard}>
//         <div className={styles.heroBanner}>
//           <div className={styles.avatarCircle}>{stage.emoji}</div>
//           <div className={styles.heroTitle}>{stage.label}</div>
//           <div className={styles.heroAge}>({stage.age})</div>
//         </div>

//         <div className={styles.heroBody}>
//           <p className={styles.desc}>{stage.desc}</p>
//           <div className={styles.tags}>
//             {stage.tags.map((tag) => (
//               <span key={tag} className={styles.tag}>{tag}</span>
//             ))}
//           </div>
//         </div>

//         {stage.focusAreas && (
//           <>
//             <div className={styles.divider} />
//             <div className={styles.focusWrap}>
//               <h4 className={styles.focusTitle}>Key focus areas</h4>
//               {stage.focusAreas.map((f, i) => (
//                 <div
//                   key={i}
//                   className={styles.focusItem}
//                   style={i === stage.focusAreas.length - 1 ? { borderBottom: "none" } : {}}
//                 >
//                   <span className={styles.focusIcon}>{f.icon}</span>
//                   <span className={styles.focusText}>{f.text}</span>
//                 </div>
//               ))}
//             </div>
//           </>
//         )}

//         <button className={styles.primaryOutlineBtn} onClick={onSeeActions}>
//           See recommended actions
//         </button>
//       </div>
//     </div>
//   );
// }

// /* ─── Journey Screen ─── */
// function JourneyScreen({ onStageClick }) {
//   return (
//     <div className={styles.screenWrap}>
//       <div className={styles.chatRow}>
//         <img
//             src="/images/chatbotFemCare.svg"
//             alt="Avexa AI Chatbot"
//             width={52}
//             height={52}
//             className={styles.avatar}
//           />
//         <div>
//           <div className={styles.chatBubble}>
//             Here's your complete life-stage journey. Tap any stage to know more.
//           </div>
//           <div className={styles.chatTime}>10:33 AM</div>
//         </div>
//       </div>

//       <div className={styles.sectionTitle}>Your journey</div>

//       <div className={styles.timeline}>
//         {STAGES.map((stage, i) => (
//           <div key={stage.id}>
//             <button
//               className={[styles.tlItem, stage.status === "current" ? styles.tlCurrent : ""].join(" ")}
//               onClick={() => onStageClick(stage.id)}
//             >
//               <div className={styles.tlIcon} style={{ background: stage.bg }}>
//                 {stage.emoji}
//               </div>
//               <div className={styles.tlLabel}>
//                 <div className={[styles.tlName, stage.status === "current" ? styles.tlNameCurrent : ""].join(" ")}>
//                   {stage.label}
//                 </div>
//                 <div className={styles.tlAge}>{stage.age}</div>
//               </div>
//               {stage.status === "completed" && (
//                 <span className={[styles.badge, styles.badgeSuccess].join(" ")}>✓ Completed</span>
//               )}
//               {stage.status === "current" && (
//                 <span className={[styles.badge, styles.badgeCurrent].join(" ")}>Current</span>
//               )}
//             </button>
//             {i < STAGES.length - 1 && (
//               <div className={styles.tlConnector} style={{ background: stage.color }} />
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ─── Rec Card ─── */
// function RecCard({ rec }) {
//   return (
//     <a href={rec.link} className={styles.recCard}>
//       <div className={styles.recIcon} style={{ background: rec.iconBg }}>
//         {rec.icon}
//       </div>
//       <div className={styles.recContent}>
//         <div className={styles.recTitle}>{rec.title}</div>
//         <div className={styles.recDesc}>{rec.desc}</div>
//       </div>
//       <span
//         className={styles.recBadge}
//         style={{ color: rec.typeColor, background: rec.typeBg }}
//       >
//         {rec.type} ›
//       </span>
//     </a>
//   );
// }

// /* ─── Recommendations Screen ─── */
// function RecommendationsScreen() {
//   return (
//     <div className={styles.screenWrap}>
//       <div className={styles.chatRow}>
//         <img
//             src="/images/chatbotFemCare.svg"
//             alt="Avexa AI Chatbot"
//             width={52}
//             height={52}
//             className={styles.avatar}
//           />
//         <div>
//           <div className={styles.chatBubble}>
//             Here are some personalized recommendations for you.
//           </div>
//           <div className={styles.chatTime}>10:34 AM</div>
//         </div>
//       </div>

//       <div className={styles.sectionTitle}>Top recommendations</div>
//       <div className={styles.recList}>
//         {RECOMMENDATIONS.map((r) => <RecCard key={r.id} rec={r} />)}
//       </div>

//       <div className={[styles.sectionTitle, styles.sectionTitleMt].join(" ")}>You may also like</div>
//       <div className={styles.recList}>
//         {ALSO_LIKE.map((r) => <RecCard key={r.id} rec={r} />)}
//       </div>
//     </div>
//   );
// }

// /* ─── Support Screen ─── */
// function SupportScreen({ onHome, onExplore }) {
//   return (
//     <div className={styles.screenWrap}>
//       <div className={styles.chatRow}>
//         <img
//             src="/images/chatbotFemCare.svg"
//             alt="Avexa AI Chatbot"
//             width={52}
//             height={52}
//             className={styles.avatar}
//           />
//         <div>
//           <div className={styles.chatBubble}>
//             I'll be with you at every stage of your journey. You're never alone.{" "}
//             <span role="img" aria-label="heart">💜</span>
//           </div>
//           <div className={styles.chatTime}>10:35 AM</div>
//         </div>
//       </div>

//       <div className={styles.sectionTitle}>Ways I can support you</div>

//       <div className={styles.supportCard}>
//         {SUPPORT_ITEMS.map((item, i) => (
//           <div
//             key={i}
//             className={styles.supportItem}
//             style={i === SUPPORT_ITEMS.length - 1 ? { borderBottom: "none" } : {}}
//           >
//             <div className={styles.supportIco}>{item.icon}</div>
//             <span className={styles.supportText}>{item.text}</span>
//           </div>
//         ))}
//       </div>

//       <div className={styles.expertCard}>
//         <div className={styles.expertAvatar}>👩‍⚕️</div>
//         <div className={styles.expertInfo}>
//           <div className={styles.expertTitle}>Need to talk to a care expert?</div>
//           <div className={styles.expertDesc}>Our care team is here to help you anytime.</div>
//         </div>
//       </div>

//       <button className={styles.chatExpertBtn}>Chat with care expert</button>

//       <div className={styles.supportActions}>
//         <button className={styles.outlineBtn} onClick={onHome}>Go to home</button>
//         <button className={styles.primaryBtn} onClick={onExplore}>Explore programs</button>
//       </div>
//     </div>
//   );
// }

// /* ─── Root ─── */
// export default function LifeStageScreen({ onBack }) {
//   const [activeTab, setActiveTab] = useState("select");
//   const [selectedStageId, setSelectedStageId] = useState("reproductive");

//   const currentStage = STAGES.find((s) => s.id === selectedStageId) || STAGES[1];

//   const handleSelect = (id) => {
//     setSelectedStageId(id);
//     setActiveTab("detail");
//   };

//   const handleStageClick = (id) => {
//     setSelectedStageId(id);
//     setActiveTab("detail");
//   };

//   return (
//     <div className={styles.root}>
//       <div className={styles.header}>
//         <div className={styles.padding}>
//         <button className={styles.backBtn} onClick={onBack}>
//           ← Back
//         </button>
//       </div>
//       </div>

//       <div className={styles.content}>
//         {activeTab === "select" && <SelectionGrid onSelect={handleSelect} />}
//         {activeTab === "detail" && (
//           <StageDetailScreen
//             stage={currentStage}
//             onSeeActions={() => setActiveTab("recs")}
//           />
//         )}
//         {activeTab === "journey" && <JourneyScreen onStageClick={handleStageClick} />}
//         {activeTab === "recs" && <RecommendationsScreen />}
//         {activeTab === "support" && (
//           <SupportScreen
//             onHome={() => setActiveTab("select")}
//             onExplore={() => setActiveTab("recs")}
//           />
//         )}
//       </div>


//     </div>
//   );
// }
import { useState } from "react";
import styles from "./LifeStageScreen.module.css";
import botStyles from '../HealthChat.module.css';

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */

const STAGES = [
  {
    id: "adolescence",
    label: "Adolescence",
    age: "13–19 years",
    emoji: "👧",
    color: "#BA68C8",
    bg: "#F3E5F5",
    desc:
      "A transformative phase of growth, self-discovery, and building healthy habits that last a lifetime.",
    tags: ["Hormonal changes", "Period health", "Nutrition", "Mental wellness"],
    status: "completed",
  },

  {
    id: "reproductive",
    label: "Reproductive Health",
    age: "26–35 years",
    emoji: "👩",
    color: "#4A148C",
    bg: "#EDE7F6",
    desc:
      "A phase of building health, managing hormones, planning your future and achieving your goals.",
    tags: [
      "Hormonal balance",
      "Fertility planning",
      "PCOS care",
      "Lifestyle",
      "Mental wellbeing",
    ],
    status: "current",

    focusAreas: [
      { icon: "⚖️", text: "Hormonal balance" },
      { icon: "🌙", text: "Menstrual & cycle health" },
      { icon: "🔬", text: "PCOS & hormonal conditions" },
      { icon: "💫", text: "Fertility & family planning" },
      { icon: "🥗", text: "Nutrition & fitness" },
      { icon: "💜", text: "Mental wellbeing" },
    ],
  },

  {
    id: "fertility",
    label: "Fertility & Family Planning",
    age: "Planning your future",
    emoji: "❤️",
    color: "#E91E63",
    bg: "#FCE4EC",
    desc:
      "Understanding fertility, planning for the future, and making informed decisions about family.",
    tags: ["Fertility tracking", "Preconception care", "IVF support"],
    status: "upcoming",
  },

  {
    id: "pregnancy",
    label: "Pregnancy",
    age: "Nurturing new life",
    emoji: "🤰",
    color: "#E91E63",
    bg: "#FCE4EC",
    desc:
      "Supporting you through every trimester with expert guidance and compassionate care.",
    tags: ["Prenatal care", "Nutrition", "Mental health"],
    status: "upcoming",
  },

  {
    id: "postpartum",
    label: "Postpartum",
    age: "Recovery & new beginnings",
    emoji: "🍼",
    color: "#F06292",
    bg: "#FCE4EC",
    desc:
      "Recovery, bonding, and adjusting to life's most beautiful new chapter.",
    tags: ["Recovery", "Breastfeeding", "Baby blues"],
    status: "upcoming",
  },

  {
    id: "perimenopause",
    label: "Perimenopause",
    age: "Hormonal transitions",
    emoji: "🌸",
    color: "#FFA000",
    bg: "#FFF4E5",
    desc:
      "Navigating hormonal shifts with grace, knowledge, and the right support.",
    tags: ["Hot flashes", "Mood changes", "Sleep health"],
    status: "upcoming",
  },

  {
    id: "menopause",
    label: "Menopause",
    age: "Embrace the change",
    emoji: "🦋",
    color: "#FF7043",
    bg: "#FBE9E7",
    desc:
      "A new chapter of freedom and wisdom. Thrive through the change.",
    tags: ["HRT", "Bone health", "Cardiovascular"],
    status: "upcoming",
  },

  {
    id: "aging",
    label: "Healthy Aging",
    age: "60+ years",
    emoji: "✨",
    color: "#4CAF50",
    bg: "#E8F5E9",
    desc:
      "Vibrant, active aging with focus on longevity, vitality, and joyful living.",
    tags: ["Bone density", "Cognitive health", "Active lifestyle"],
    status: "upcoming",
  },
];

const LIFE_STAGE_GRID = [
  {
    id: "adolescence",
    label: "Adolescence",
    icon: "👧",
  },

  {
    id: "reproductive",
    label: "Reproductive Age",
    icon: "👩",
  },

  {
    id: "fertility",
    label: "Fertility",
    icon: "❤️",
  },

  {
    id: "pregnancy",
    label: "Pregnancy",
    icon: "🤰",
  },
];

const RECOMMENDATIONS = [
  {
    id: "pcos",
    title: "PCOS Risk Assessment",
    desc: "Understand your risk and get personalized insights.",
    icon: "🔬",
    iconBg: "#F3E5F5",
    type: "Assessment",
    typeColor: "#4CAF50",
    typeBg: "#E8F5E9",
    link: "/health-assessment",
  },

  {
    id: "hormonal",
    title: "Hormonal Balance Program",
    desc: "Balance your hormones and feel your best.",
    icon: "🌿",
    iconBg: "#E8F5E9",
    type: "Program",
    typeColor: "#4A148C",
    typeBg: "#EDE7F6",
    link: "/programs",
  },

  {
    id: "nutrition",
    title: "Nutrition for Hormone Health",
    desc: "Personalized diet plans for hormonal balance.",
    icon: "🥗",
    iconBg: "#FFF4E5",
    type: "Program",
    typeColor: "#FFA000",
    typeBg: "#FFF8E1",
    link: "/programs",
  },

  {
    id: "consult",
    title: "Book a Gynecologist",
    desc: "Consult a specialist for personalized care.",
    icon: "📋",
    iconBg: "#FCE4EC",
    type: "Consult",
    typeColor: "#E91E63",
    typeBg: "#FCE4EC",
    link: "/book-appointment",
  },
];

const SUPPORT_ITEMS = [
  { icon: "💬", text: "Answer your health questions" },
  { icon: "🔍", text: "Help you understand symptoms" },
  { icon: "🧭", text: "Guide you to the right care" },
  { icon: "✅", text: "Track your health & progress" },
  { icon: "⭐", text: "Recommend programs & experts" },
  { icon: "🎉", text: "Celebrate your milestones" },
];

/* ─────────────────────────────────────────────
   STEP 1 — SELECT SCREEN
───────────────────────────────────────────── */

function SelectionGrid({ onSelect }) {
  return (
    <div className={styles.screenWrap}>
      <div className={styles.pageHead}>
        <h2 className={styles.pageTitle}>Life Stage</h2>

        <p className={styles.pageSub}>
          Select the stage that best describes you
        </p>
      </div>

      <div className={styles.grid}>
        {LIFE_STAGE_GRID.map((stage) => (
          <button
            key={stage.id}
            className={styles.gridCard}
            onClick={() => onSelect(stage.id)}
          >
            <div className={styles.gridIcon}>
              {stage.icon}
            </div>

            <div className={styles.gridLabel}>
              {stage.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   STEP 2 — DETAIL SCREEN
───────────────────────────────────────────── */

function StageDetailScreen({
  stage,
  onContinue,
}) {
  return (
    <div className={styles.screenWrap}>
      {/* <div className={styles.chatRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />

        <div>
          <div className={styles.chatBubble}>
            Based on your responses, you are in the{" "}
            <strong>{stage.label}</strong> stage.
          </div>

          <div className={styles.chatTime}>
            10:32 AM
          </div>
        </div>
      </div> */}

      <div className={styles.heroCard}>
        <div className={styles.heroBanner}>
          <div className={styles.avatarCircle}>
            {stage.emoji}
          </div>

          <div className={styles.heroTitle}>
            {stage.label}
          </div>

          <div className={styles.heroAge}>
            ({stage.age})
          </div>
        </div>

        <div className={styles.heroBody}>
          <p className={styles.desc}>
            {stage.desc}
          </p>

          <div className={styles.tags}>
            {stage.tags.map((tag) => (
              <span
                key={tag}
                className={styles.tag}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {stage.focusAreas && (
          <>
            <div className={styles.divider} />

            <div className={styles.focusWrap}>
              <h4 className={styles.focusTitle}>
                Key focus areas
              </h4>

              {stage.focusAreas.map((item, i) => (
                <div
                  key={i}
                  className={styles.focusItem}
                  style={
                    i ===
                      stage.focusAreas.length - 1
                      ? {
                        borderBottom: "none",
                      }
                      : {}
                  }
                >
                  <span
                    className={styles.focusIcon}
                  >
                    {item.icon}
                  </span>

                  <span
                    className={styles.focusText}
                  >
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}

        <button
          className={styles.primaryOutlineBtn}
          onClick={onContinue}
        >
          Continue →
        </button>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   STEP 3 — JOURNEY SCREEN
───────────────────────────────────────────── */

function JourneyScreen({
  selectedStageId,
  onContinue,
}) {
  return (
    <div className={styles.screenWrap}>
      {/* <div className={styles.chatRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />

        <div>
          <div className={styles.chatBubble}>
            Here’s your complete life-stage
            journey.
          </div>

          <div className={styles.chatTime}>
            10:33 AM
          </div>
        </div>
      </div> */}

      <div className={styles.sectionTitle}>
        Your Journey
      </div>

      <div className={styles.timeline}>
        {STAGES.map((stage, i) => (
          <div key={stage.id}>
            <div
              className={[
                styles.tlItem,
                selectedStageId === stage.id
                  ? styles.tlCurrent
                  : "",
              ].join(" ")}
            >
              <div
                className={styles.tlIcon}
                style={{
                  background: stage.bg,
                }}
              >
                {stage.emoji}
              </div>

              <div className={styles.tlLabel}>
                <div
                  className={[
                    styles.tlName,
                    selectedStageId ===
                      stage.id
                      ? styles.tlNameCurrent
                      : "",
                  ].join(" ")}
                >
                  {stage.label}
                </div>

                <div className={styles.tlAge}>
                  {stage.age}
                </div>
              </div>

              {selectedStageId ===
                stage.id && (
                  <span
                    className={[
                      styles.badge,
                      styles.badgeCurrent,
                    ].join(" ")}
                  >
                    Current
                  </span>
                )}
            </div>

            {i < STAGES.length - 1 && (
              <div
                className={styles.tlConnector}
                style={{
                  background: stage.color,
                }}
              />
            )}
          </div>
        ))}
      </div>

      <button
        className={styles.primaryOutlineBtn}
        onClick={onContinue}
      >
        Continue →
      </button>
    </div>
  );
}


/* ─────────────────────────────────────────────
   STEP 4 — RECOMMENDATIONS SCREEN
───────────────────────────────────────────── */

function RecommendationsScreen({
  onContinue,
}) {
  return (
    <div className={styles.screenWrap}>
      {/* <div className={styles.chatRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />

        <div>
          <div className={styles.chatBubble}>
            Here are personalized
            recommendations for you.
          </div>

          <div className={styles.chatTime}>
            10:34 AM
          </div>
        </div>
      </div> */}

      <div className={styles.sectionTitle}>
        Top Recommendations
      </div>

      <div className={styles.recList}>
        {RECOMMENDATIONS.map((rec) => (
          <a
            key={rec.id}
            href={rec.link}
            className={styles.recCard}
          >
            <div
              className={styles.recIcon}
              style={{
                background: rec.iconBg,
              }}
            >
              {rec.icon}
            </div>

            <div className={styles.recContent}>
              <div className={styles.recTitle}>
                {rec.title}
              </div>

              <div className={styles.recDesc}>
                {rec.desc}
              </div>
            </div>

            <span
              className={styles.recBadge}
              style={{
                color: rec.typeColor,
                background: rec.typeBg,
              }}
            >
              {rec.type} ›
            </span>
          </a>
        ))}
      </div>

      <button
        className={styles.primaryOutlineBtn}
        onClick={onContinue}
      >
        Continue →
      </button>
    </div>
  );
}

/* ─────────────────────────────────────────────
   STEP 5 — SUPPORT SCREEN
───────────────────────────────────────────── */

function SupportScreen({
  onRestart,
}) {
  return (
    <div className={styles.screenWrap}>
      {/* <div className={styles.chatRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />

        <div>
          <div className={styles.chatBubble}>
            I’ll be with you throughout your
            health journey 💜
          </div>

          <div className={styles.chatTime}>
            10:35 AM
          </div>
        </div>
      </div> */}

      <div className={styles.sectionTitle}>
        Ways I can support you
      </div>

      <div className={styles.supportCard}>
        {SUPPORT_ITEMS.map((item, i) => (
          <div
            key={i}
            className={styles.supportItem}
            style={
              i === SUPPORT_ITEMS.length - 1
                ? {
                  borderBottom: "none",
                }
                : {}
            }
          >
            <div className={styles.supportIco}>
              {item.icon}
            </div>

            <span className={styles.supportText}>
              {item.text}
            </span>
          </div>
        ))}
      </div>

      <div className={styles.expertBtnCard}>
        <button className={styles.chatExpertBtn}>
          Chat with care expert
        </button>

        <button
          className={styles.outlineAgainBtn}
          onClick={onRestart}
        >
          Start Again →
        </button>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   ROOT COMPONENT
───────────────────────────────────────────── */
const STEP_CONFIG = {
  1: {
    title: "Hi, I'm your Care Navigator",
    subtitle: "What life stage are you currently in?",
    previous: null,
  },
  2: {
    title: "Your Life Stage",
    subtitle: (stageName) => `Based on your responses, you are in the ${stageName} stage.`,
    previous: 1,
  },
  3: {
    title: "Your Journey",
    subtitle: "Let's map out what to expect",
    previous: 2,
  },
  4: {
    title: "Recommendations",
    subtitle: "Personalised for your stage",
    previous: 3,
  },
  5: {
    title: "Your Support Plan",
    subtitle: "Here's how we can help you",
    previous: 4,
  },
};

export default function LifeStageScreen({
  onBack,
}) {
  const [step, setStep] = useState(1);

  const [selectedStageId, setSelectedStageId] =
    useState("reproductive");
  const currentStep = STEP_CONFIG[step];

  const currentStage =
    STAGES.find(
      (stage) =>
        stage.id === selectedStageId
    ) || STAGES[1];
  const subtitle = typeof currentStep.subtitle === "function"
    ? currentStep.subtitle(currentStage.label)
    : currentStep.subtitle;

  const handleStageSelect = (id) => {
    setSelectedStageId(id);
    setStep(2);
  };

  return (
    <div className={botStyles.symptomPickerScreen}>
      {/* HEADER */}
      {/* <div className={styles.header}> */}
        {/* <div className={styles.padding}> */}
          <button
            className={botStyles.selectDoctorBack}
            onClick={onBack}
          >
            ← Back
          </button>
        {/* </div> */}
      {/* </div> */}
      <div className={botStyles.symptomPickerBotRow}>
        <img
          src="/images/chatbot.svg"
          alt="bot"
          width={48}
          height={48}
          className={botStyles.symptomPickerBotImg}
        />
        <div className={`${botStyles.symptomPickerBotBubble} ${botStyles.CBbodyText}`}>
          <strong>{currentStep.title}</strong>
          <p style={{ fontSize: "0.85rem", margin: 0, opacity: 0.9 }}>
            {/* {currentStep.subtitle} */}  {subtitle}
          </p>
        </div>
      </div>
      {/* CONTENT */}

      <div className={styles.content}>
        {/* STEP 1 */}

        {step === 1 && (
          <SelectionGrid
            onSelect={handleStageSelect}
          />
        )}

        {/* STEP 2 */}

        {step === 2 && (
          <StageDetailScreen
            stage={currentStage}
            onContinue={() => setStep(3)}
          />
        )}

        {/* STEP 3 */}

        {step === 3 && (
          <JourneyScreen
            selectedStageId={
              selectedStageId
            }
            onContinue={() => setStep(4)}
          />
        )}

        {/* STEP 4 */}

        {step === 4 && (
          <RecommendationsScreen
            onContinue={() => setStep(5)}
          />
        )}

        {/* STEP 5 */}

        {step === 5 && (
          <SupportScreen
            onRestart={() => setStep(1)}
          />
        )}
      </div>
    </div>
  );
}